import { EventType } from './events.js';
/** True when the event carries a full DOM snapshot (a replay keyframe). */
export function isFullSnapshot(e) {
    return e.type === EventType.FullSnapshot;
}
/** True when the event is an incremental snapshot of the given source. */
export function isIncrementalOf(e, source) {
    return (e.type === EventType.IncrementalSnapshot &&
        typeof e.data === 'object' &&
        e.data !== null &&
        e.data.source === source);
}
/** True when the event is a captured native screen frame. */
export function isNativeFrame(e) {
    return e.type === EventType.NativeFrame;
}
/**
 * True when a recording is a native (iOS/Android) session rather than a DOM
 * one. Decided from the events themselves so a replay can pick its player
 * without trusting session metadata that may predate the platform column.
 */
export function isNativeRecording(events) {
    return events.some(isNativeFrame);
}
/**
 * Returns the index of the last full snapshot at or before `timestamp`.
 * The replay engine seeks by replaying from the nearest keyframe forward.
 */
export function findKeyframeIndex(events, timestamp) {
    let idx = -1;
    for (let i = 0; i < events.length; i++) {
        const e = events[i];
        if (e && e.timestamp <= timestamp && isFullSnapshot(e))
            idx = i;
        else if (e && e.timestamp > timestamp)
            break;
    }
    return idx;
}
//# sourceMappingURL=guards.js.map